import { respondTo } from '@legacy-vfuk/core-mixins';
import styled, { css } from 'styled-components';

export const SectionContainer = styled.div<{
  backgroundColor: 'white' | 'grey';
}>`
  background: ${props =>
    props.backgroundColor === 'white' ? 'var(--white)' : 'var(--gallery)'};
  padding: 40px 16px;
`;

export const SimpleBandContainer = styled.div`
  max-width: 1280px;
  margin: auto;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr;
  gap: 16px;


  [class^='RichTextstyles__ParsedContentWrapper'] {
    p {
      font-size: 20px;
      line-height: 28px;
    }
  }

  ${respondTo.md(
  css`
      grid-template-columns: 1fr 1fr;
      gap: 40px;
    `
)}
`;

export const ImageContainer = styled.div<{ imageAlignment: 'left' | 'right' }>`
  ${respondTo.md(
  css`
      [data-gatsby-image-wrapper] {
        min-height: 300px;
      }
    `
)}
  img {
    border-radius: 6px;
  }


  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    order: ${props => (props.imageAlignment === 'right' ? '1' : '0')};
  }
`;
